import { SuccessMessage } from "@tlc/ls2pac/components/SuccessMessage";
import { TLCEXT } from "../../../js/lib/ext/Ext";
import { ApplicationData } from "../ls2pac/ApplicationData";
import { GlobalConfigurationClientManager } from "../ls2pac/ClientManagers/GlobalConfigurationClientManager";
import { HostSystemClientManager } from "../ls2pac/ClientManagers/HostSystemClientManager";
import { LanguageClientManager } from "../ls2pac/ClientManagers/LanguageClientManager";
import { LoginClientManager } from "../ls2pac/ClientManagers/LoginClientManager";
import { Marc21DisplayClientManager } from "../ls2pac/ClientManagers/Marc21DisplayClientManager";
import { StationLocationClientManager } from "../ls2pac/ClientManagers/StationLocationClientManager";
import { TimeoutPageControl } from "../ls2pac/controls/timeoutPageControl";
import { ResourceUtils } from "../ls2pac/utils/resourceUtils";
import { LibraryThing } from "../ls2pac/widget/LibraryThingWidget";
import { KidsAjaxMonitor } from "./AjaxMonitor";
import { KidsRoutesTable } from "./RoutesTable";
import { LS2KIDS_CONSTANTS } from "./constants";
import { KidsTimeoutPageControl } from "./controls/timeoutPageControl";
// import { HarlemShake } from "./harlemShake";
import { KidsLoader } from "./loader";
import { KidsGoogleAnalyticsManager } from "./managers/GoogleAnalyticsManager";
import { KidsHistoryManager } from "./managers/HistoryManager";
import { KidsSearchDatabaseManager } from "./managers/SearchDatabaseManager";
import { KidsCategoryManager } from "./managers/categoryManager";
import { KidsSeriesManager } from "./managers/seriesManager";
import { KidsMessaging } from "./messaging";
import { KidsClassicTheme } from "./themes/ClassicTheme";
import { ThemeHolder } from "./themes/ThemeHolder";
import { KidsUtil } from "./utils";
import { KidsCategoryView } from "./views/CategoryView";
import { KidsFooterView } from "./views/FooterView";
import { KidsFullDetailsView } from "./views/FullDetailsView";
import { KidsHeaderView } from "./views/HeaderView";
import { KidsHoldsView } from "./views/HoldsView";
import { KidsResultsView } from "./views/ResultsView";
import { KidsSeriesView } from "./views/SeriesView";
import * as React from "react";
import {
  LocationConfigurationHolder,
  LocationConfigurationProvider,
} from "@tlc/ls2pac/components/LocationConfiguration";
import { GlobalConfigHolder, GlobalConfigProvider } from "@tlc/ls2pac/components/GlobalConfig";
import { SupportedFunctionalityProvider } from "@tlc/ls2pac/components/SupportedFunctionality";
import { LoginDialog } from "@tlc/ls2pac/components/LoginDialog";
import { renderWithoutShadow } from "@tlc/ls2pac/components/ShadowUtils";
import { WindowLocationProvider } from "@tlc/ls2pac/components/WindowLocation";
import { StationLocationProvider } from "@tlc/ls2pac/components/StationLocation";
import { WindowVariablesProvider } from "@tlc/ls2pac/components/WindowVariables";
import { AccountHolder } from "@tlc/ls2pac/components/Account";
import { TLCEventManager } from "src/main/resources/js/lib/events/EventManager";
import { LS2PAC_CONSTANTS } from "src/main/resources/js/main/constants";
import { LoginContextProvider } from "@tlc/ls2pac/components/LoginContext";
import { KidsLocationProvider } from "@tlc/ls2pac/components/KidsLocationProvider";

Marc21DisplayClientManager.setUrl(LS2KIDS_CONSTANTS.restUrls.fullDetails);

// tlc.managers = {};
// tlc.managers.HistoryManager = {};
// tlc.managers.HistoryManager.clear = function () {};

$.ajaxSetup({
  headers: {
    "Ls2pac-config-type": "kids",
  },
});

export class LS2KidsMain {
  constructor() {}
  /**
   * The main app start.
   */
  static start() {
    if (
      window.navigator.userAgent.match(/iPad;.*CPU.*OS 7_\d/i) &&
      !window.navigator.userAgent.match(/CriOS/i)
    ) {
      if (window.navigator.standalone) {
        $("html").addClass("ipad-standalone ios7-standalone");
      } else {
        $("html").addClass("ipad ios7");
      }
    }

    // conditional comments do not exist anymore in IE10, thanks MS
    if (window.navigator.userAgent.toLowerCase().indexOf("trident") > -1) {
      $("html").addClass("ie");
    }

    LS2KidsMain._disableScroll();

    ThemeHolder.activeTheme = new KidsClassicTheme();

    KidsAjaxMonitor.init();

    TLCEXT.setBaseData({
      ls2kidsConstants: LS2KIDS_CONSTANTS,
      ls2kidsUtils: KidsUtil,
      resourceUtil: ResourceUtils,
      SVN_REVISION: window["svnRevision"],
      LIBRARY_NAME: window["libraryName"],
    });

    KidsLoader.start([
      { eventToFire: HostSystemClientManager.getSupportedFunctionalityEvent },
      { eventToFire: LanguageClientManager.getAvailableLanguagesEvent },
      { eventToFire: LanguageClientManager.getLanguageEvent },
      {
        funcWithCallback: function (callback) {
          TLCEXT.setBaseData({
            languageUtil: ApplicationData.language,
          });
          callback();
        },
      },
      {
        funcWithCallback: async function (callback) {
          await GlobalConfigHolder.fetchGlobalConfig();
          callback();
        },
      },
      {
        funcWithCallback: async function (callback) {
          await LocationConfigurationHolder.fetchLocationConfiguration();
          callback();
        },
      },
      { eventToFire: KidsSeriesManager.getSeriesEvent },
      { eventToFire: KidsCategoryManager.getCategoriesEvent },
      {
        eventToFire:
          GlobalConfigurationClientManager.getGlobalConfigurationEvent,
      },
      {
        funcWithCallback: function (callback) {
          LS2KidsMain._onUIBuild();
          KidsGoogleAnalyticsManager.init(); // header and footer view fire events this manager looks for
          LS2KidsMain._headerView = new KidsHeaderView();
          LS2KidsMain._footerView = new KidsFooterView();

          window.requestAnimationFrame(function () {
            callback();
          });
        },
      },
      {
        funcWithCallback: async (callback) => {
          const { isAuthenticated, user } =
            await AccountHolder.fetchAccountData();
          return callback();
        },
      },
      { eventToFire: StationLocationClientManager.getCurrentBranchEvent },
      {
        funcWithCallback: function (callback) {
          LibraryThing.initConfig(ApplicationData.language, callback);
        },
      },
    ]).then(LS2KidsMain._ready, LS2KidsMain._fail);

    // HarlemShake.init();
  }
  /**
   * Init all the views
   */
  static initViews() {
    LS2KidsMain._categoryView = new KidsCategoryView();
    LS2KidsMain._seriesView = new KidsSeriesView();
    LS2KidsMain._resultsView = new KidsResultsView();
    LS2KidsMain._fullDetailsView = new KidsFullDetailsView();
    LS2KidsMain._holdsView = new KidsHoldsView();

    //	alert( $( "#app-main" ).width() + "x" + $( "#app-main" ).height() );
  }
  /**
   * Handler for when the app does not load.
   * @private
   */
  static _fail() {
    alert("We are sorry, the app failed to load.");
  }
  /**
   * If a user comes on this from a tablet, we add a class to the app itself and
   * disable the elastic scrolling on some devices
   *
   * @private
   */
  static _disableScroll() {
    if (
      window.Modernizr.touch &&
      window.navigator.userAgent.toLowerCase().indexOf("windows") == -1
    ) {
      $("#" + LS2KIDS_CONSTANTS.Ids.mainContent).addClass("touchEnabled");
    }

    if (document.body.addEventListener) {
      document.body.addEventListener(
        "touchmove",
        function (e) {
          e.preventDefault();
        },
        false
      );
    }
  }
  /**
   * an opportunity to perform some work before crucial UI pieces are rendered for the first time.
   */
  static _onUIBuild() {
    if (ApplicationData.locationConfiguration.kidsLandingPage() == "series") {
      LS2KIDS_CONSTANTS.Urls.__start = LS2KIDS_CONSTANTS.Urls.series;
    } else {
      LS2KIDS_CONSTANTS.Urls.__start = LS2KIDS_CONSTANTS.Urls.categories;
    }
  }
  /**
   * The loader has finished and the app should now start.
   * @private
   */
  static _ready() {
    const divElement = document.createElement("div");
    divElement.id = "react-app";
    document.body.appendChild(divElement);

    renderWithoutShadow(
      <div id="app-root">
        <SuccessMessage></SuccessMessage>
        <LocationConfigurationProvider>
          <GlobalConfigProvider>
            <SupportedFunctionalityProvider>
                <WindowVariablesProvider>
                  <StationLocationProvider>
                  <LoginContextProvider>
                    <KidsLocationProvider>
                      <LoginDialog isKids={true}></LoginDialog>
                    </KidsLocationProvider>
                  </LoginContextProvider>
                  </StationLocationProvider>
                </WindowVariablesProvider>
            </SupportedFunctionalityProvider>
          </GlobalConfigProvider>
        </LocationConfigurationProvider>
      </div>,
      divElement,
      ApplicationData.language,
      true
    );

    // the 400ms delay hack for touch
    if (window.Modernizr.touch) {
      $("#app-main")
        .on("touchstart", "a", KidsUtil.onTouchStartTimingHack)
        .on("touchend", "a", function (e) {
          if (e.isDefaultPrevented()) {
            console.log(
              "touchend occured on a tag, but event defaultPrevented"
            );
          } else {
            KidsUtil.onTouchEndTimingHack(e, function (e) {
              var href = $(e.currentTarget).attr("href");
              if (href.length > 0 && href.indexOf("javascript:") == -1) {
                location.href = href;

                e.preventDefault();
              }
            });
          }
        });
    }

    TimeoutPageControl.init();
    LS2KidsMain.initViews();
    KidsTimeoutPageControl.init(
      LS2KidsMain._categoryView,
      LS2KidsMain._seriesView
    );

    //this is where all the search magic is configured
    KidsSearchDatabaseManager.setupSearchDatabases();

    // site wide messaging, a talk bubble from scout
    KidsMessaging.init();

    // render the header and footer
    if (!LS2KidsMain._headerView) {
      LS2KidsMain._headerView = new KidsHeaderView();
    }

    if (!LS2KidsMain._footerView) {
      LS2KidsMain._footerView = new KidsFooterView();
    }

    var routes = new KidsRoutesTable();

    window.requestAnimationFrame(function () {
      // fire state change, this will fire the view that should be active.
      KidsHistoryManager.init(routes);
    });
  }
}
